// Instructions on how to import other JS files into this one.
// https://babeljs.io/learn-es2015/#modules
// http://exploringjs.com/es6/ch_modules.html
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/export

import 'babel-polyfill'
import * as mobileNav from './mobile-nav'
import * as desktopNav from './desktop-nav'
import * as search from './search'
import * as fontSize from './font-size'
import * as emergencyAlerts from './emergency-alerts'

mobileNav.initialize()
desktopNav.initialize()
search.initialize()
fontSize.initialize()
emergencyAlerts.initialize()

import * as vueMeei from './vue-meei'
import * as carouselSlider from './carousel-slider'
import * as accordions from './accordions'
import * as googleTranslate from './google-translate'
import * as relatedContentSlider from './related-content-slider'
import * as newsletterSignup from './newsletter-signup'
import * as commonSymptoms from './common-symptoms'
import * as meeiTweets from './meei-tweets'
import * as locations from './locations'
import * as searchFilters from './search-filters'
import * as footer from './footer';
import * as pageLoad from './pageload';
import * as animationEffects from './animation-effects';
import * as forms from './forms';
import * as persistentCta from './persistent-cta';

$(document).ready(function() {
	footer.makeFooterHeadlinesUnTabbable();
	commonSymptoms.commonSymptomColumns();
	pageLoad.pageLoaded();
	checkForZoom();
	$(window).resize(function() {
		footer.makeFooterHeadlinesUnTabbable();	
		checkForZoom();
	});
});

function checkForZoom() {
	var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
	if(browserZoomLevel > 200) {
		$('body').addClass('zoomed');
	} else {
		if($('body').hasClass('zoomed')) {
			$('body').removeClass('zoomed');				
		}
	}
}


// Checks the browser and adds classes to the body to reflect it.
var BrowserDetect = {
    init: function () {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
    },
    searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;

            if (dataString.indexOf(data[i].subString) !== -1) {
                return data[i].identity;
            }
        }
    },
    searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index === -1) {
            return;
        }

        var rv = dataString.indexOf("rv:");
        if (this.versionSearchString === "Trident" && rv !== -1) {
            return parseFloat(dataString.substring(rv + 3));
        } else {
            return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
        }
    },

    dataBrowser: [
        {string: navigator.userAgent, subString: "Edge", identity: "MS Edge"},
        {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
        {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
        {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
        {string: navigator.userAgent, subString: "Opera", identity: "Opera"},  
        {string: navigator.userAgent, subString: "OPR", identity: "Opera"},  

        {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"}, 
        {string: navigator.userAgent, subString: "Safari", identity: "Safari"}       
    ]
};
    
    BrowserDetect.init();
    $('body').addClass(BrowserDetect.browser);